/**
 * Props for LoginScreen component
 * Contains form state and handlers
 */
export interface LoginScreenBaseProps {
  formData: {
    email: string
    password: string
    otp: string
  }
  loginMode: 'otp' | 'password'
  otpSent: boolean
  showPassword: boolean
  rememberMe: boolean
  loading: boolean
  sendingOtp: boolean
  error: string
  onFormDataChange: (updates: Partial<{ email: string; password: string; otp: string }>) => void
  onLoginModeChange: (mode: 'otp' | 'password') => void
  onSendOtp: () => void
  onShowPasswordChange: (show: boolean) => void
  onRememberMeChange: (remember: boolean) => void
  onClearField: (field: 'email' | 'password' | 'otp') => void
  onSubmit: (e: React.FormEvent) => void
}

/**
 * Default form data for login
 */
export const getDefaultLoginFormData = () => ({
  email: '',
  password: '',
  otp: ''
})

